import { render, staticRenderFns } from "./screen-card-menu-day.vue?vue&type=template&id=359625e2"
import script from "./screen-card-menu-day.vue?vue&type=script&lang=ts"
export * from "./screen-card-menu-day.vue?vue&type=script&lang=ts"
import style0 from "./screen-card-menu-day.vue?vue&type=style&index=0&id=359625e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports